import { snakeCase } from "lodash";
export function toSnakeCase(str: string): string {
  return snakeCase(str);
}
